import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    scorePane: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '6px 12px',
        borderRadius: 8,
        userSelect: 'none',
        '& p': {
            fontWeight: 500
        }
    },
    scoreAccent: {
        width: 4,
        height: 16,
        borderRadius: 100,
        marginRight: 4
    },
    scoreText: {
        fontSize: 12,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row'
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        color: '#979797',
        fontWeight: 400
    }
});
